import { FC } from "react";

interface DisplayPercentageProps {
    value: number;
    multiplier?: number;
    minimumDP?: number;
    maximumDP?: number;
}

export const DisplayPercentage: FC<DisplayPercentageProps> = (props) => {
    return (
        <span>
            {
                new Intl.NumberFormat(navigator.language, {
                    style: "percent",
                    minimumFractionDigits: props.minimumDP,
                    maximumFractionDigits: props.maximumDP,
                }).format(props.value * (props.multiplier ?? 1))
            }
        </span>
    );
};